import { Box } from '@mui/material';
import TableOfContents from './TableOfContents';

export default function TableOfContentsMenu() {
  return (
    <Box sx={{ marginTop: 1.5, paddingLeft: 0.75, paddingRight: 2 }}>
      <TableOfContents />
    </Box>
  );
}
